import { Component, Input, OnInit, Output, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { PaginatedResponse } from 'src/app/core';
@Component({
  selector: 'app-paging',
  templateUrl: './paging.component.html',
  styleUrls: ['./paging.component.scss'],
})
export class PagingComponent implements OnInit, OnChanges {
  PAGENATION_SIZE = 10;

  @Input()
  items: PaginatedResponse<any>;

  // tslint:disable-next-line: no-output-on-prefix
  @Output()
  onPageChange: EventEmitter<number> = new EventEmitter();

  pages = [];
  activePage: number;
  totalPage: number;
  pageRange = [];

  constructor() {}

  ngOnInit() {}

  ngOnChanges(change: SimpleChanges) {
    if (change.items && change.items.currentValue) {
      const items = change.items.currentValue;
      this.activePage = items.page + 1;
      this.totalPage = Math.floor((items.totalCount - 1) / items.limit) + 1;
      this.items = items;
      this.getPageNumbers();
    }
  }

  getPageNumbers() {
    this.pages = [];
    const startPage = Math.floor((this.activePage - 1) / this.PAGENATION_SIZE) * this.PAGENATION_SIZE + 1;
    const endPage = Math.min(startPage + this.PAGENATION_SIZE - 1, this.totalPage);

    for (let i = startPage; endPage >= i; i++) {
      this.pages.push(i);
    }
  }

  onClickPage(page: number) {
    if (page < 1) {
      return;
    }

    if (page === this.activePage) {
      return;
    }

    if (page > this.totalPage) {
      return;
    }

    this.activePage = page;
    this.getPageNumbers();
    this.onPageChange.emit(this.activePage - 1);
  }
}
